module.exports = __webpack_public_path__ + "static/media/hortify-preto.c9dad5f7.png";